// title-favicon.service.ts
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TitleFaviconService {

  constructor(private titleService: Title) {
  }

  setTitleAndFavicon(appName: string) {

    const title = 'mydocma ' + appName;
    const faviconLink = `assets/icons/favicon-${appName}.png`;
    this.titleService.setTitle(title);
    const link: HTMLLinkElement = document.querySelector('link[rel*=\'icon\']');
    //faviconLink = `${faviconLink}?v=${Date.now()}`;
    link.href = faviconLink;
  }
}
